import axios from 'axios';
import { config } from '../config/config';

export const fetcher = async (endpoint, method, data = {}, showErrorModal, token) => {
  let headers = {
    'Content-Type': 'application/json'
  }
  // console.log('fetcher', { endpoint, method, data, showErrorModal, token });
  if (token) {
    headers.Authorization = 'Bearer ' + token;
  }
  console.log('fetcher->data', {
    url: `${config.apiUrl}${endpoint}`,
    method,
    data,
    headers: headers
  });
  try {
    const response = await axios({
      url: `${config.apiUrl}${endpoint}`,
      method,
      data,
      headers: headers
    });
    return response.data;
  } catch (error) {
    if (showErrorModal) {
      // Show error modal (implement modal handling logic)
    }
    throw error;
  }
};